<div class="progress-spinner" *ngIf="loading">
  <p-progressSpinner></p-progressSpinner>
</div>
<div *ngIf="errorMsg" class="text-center p-4">
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>
</div>
